import React, { FC } from 'react';

import { ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import { IconTypes } from 'components/Icons';

export const LearnMoreAboutDataGroup: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="data_group"
      headerTitle="Data Group"
      iconType={IconTypes.Documents}
      body={
        <Stack spacing={10}>
          <Text>
            Data Group provides a way to aggregate different data sources in
            logical way that reflects a business need, use case or scope of
            access. Data Group can contain one or more databases and schemas,
            buckets, and other similar data sources that together serve the
            business. Data Group must comprise data sources from the same cloud
            and same account.
          </Text>
          <Text>
            A Data Group also makes it easy to control access and assign dynamic
            masking policies to users and groups to enforce least privilege
            management and ensure sensitive data is protected from unauthorized
            access and use.
          </Text>
          <Stack>
            <Text>Some examples of how you might organize Data Group:</Text>
            <UnorderedList>
              <ListItem pl={4}>
                Databases that hold information that are collectively needed for
                financial analysis or reporting
              </ListItem>
              <ListItem pl={4}>
                Databases that hold relevant information to perform analytics by
                a particular group within the organization
              </ListItem>
              <ListItem pl={4}>
                Buckets that may hold marketing data required for customer
                analysis to improve customer targeting and SEO
              </ListItem>
            </UnorderedList>
          </Stack>
        </Stack>
      }
    />
  );
};
